import styled from "styled-components";
import {HeaderStandardButtonBox} from "../../boxes/header-standard-button.box";

export const RegisterButtonDefaultBox = styled(HeaderStandardButtonBox)`
`